import { render, staticRenderFns } from "./PrazoPagamento.vue?vue&type=template&id=457a0c0d"
import script from "./PrazoPagamento.vue?vue&type=script&lang=js"
export * from "./PrazoPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports